<template>
  <main>
    <section class="block--base block--column block--radius  block--margin--lr-auto block--base--no--limit">
      <div class="block--base block--row block--smd block--margin--lr-auto block--padding-1 block--base--no--limit">
        <div class="block--smd "><h1>Mon compte</h1></div>
        <div class="block--smd block--margin--auto"><router-link  :to="{ name: 'logout'}" class="btn--base btn--secondary btn--md">
            Se déconnecter
        </router-link>
        </div>
      </div>
      <customForm class="block--base block--with--background block--radius block--column block--smd block--margin--lr-auto block--padding-1 " :form="form" :loading="loading" :path="`/api/${this.user.id}/profile`" v-on:good="ending" />
    </section>
  </main>
</template>
<script>
import customForm from '@/components/customForm'

export default {
  name: 'user',
  components: {
    customForm
  },
  data () {
    return {
      form: {},
      loading: false
    }
  },
  methods: {
    ending () {
      this.$router.push({ name: 'dashboard' })
    }
  },
  mounted () {
    this.loading = true
    this.HTTP.get(`/api/${this.user.id}/profile`).then(r => {
      this.form = r.data
      this.loading = false
    })
  }
}
</script>
<style lang="scss">
</style>
